import HeroSection from "./components/HeroSection";
import CategoryNav from "./components/CategoryNav";
import HotRecommend from "./components/HotRecommend";
import LatestUpdates from "./components/LatestUpdates";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTop from "@/components/feature/ScrollToTop";
import SEOHead from "@/components/feature/SEOHead";

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <SEOHead
        title="韩国漫画免费在线观看-高清韩漫全集下拉式阅读-漫画大全-哈哈漫画网"
        description="哈哈漫画网提供韩国漫画免费在线观看，支持高清韩漫全集下拉式阅读和漫画大全，让您随时随地畅读各种作品，享受便捷的娱乐服务。恋爱、奇幻、动作、剧情、搞笑、悬疑、耽美、百合等全类型覆盖。"
        keywords="韩国漫画,免费在线观看,高清韩漫,下拉式阅读,漫画大全,哈哈漫画网,恋爱漫画,奇幻漫画,悬疑漫画"
        canonicalUrl="https://hahacomic.com/"
        ogType="website"
        schemaType="Organization"
        schemaData={{
          name: "哈哈漫画网",
          url: "https://hahacomic.com",
          description: "韩国漫画免费在线观看平台，提供高清韩漫全集下拉式阅读和漫画大全。",
        }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <HotRecommend />
        <LatestUpdates />
      </main>
      <Footer />
    </>
  );
}